import PropTypes from 'prop-types'
import {useParams} from 'react-router-dom'
import {useEffect, useRef} from 'react'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import {Input} from '../../../../../../../common/inputs/Input.jsx'
import {Row, Spinner} from "react-bootstrap";
import {usePlanHarmData} from '../../../../../../../../api/domain/elementyRejstru/queries/usePlanHarmData.jsx'
import {toCurrency} from "../../../../../../../utils/helpers/index.js";

export const BudzetProjektu = (props) => {
    const { id: rejestrId } = useParams();
    const kategoria = props.wiz?.form?.kategoria || '';
    const isKatA = kategoria === 'A';
    const lastSyncedKeyRef = useRef(null);

    const {
        data: planHarmData,
        isLoading: isLoadingPH,
    } = usePlanHarmData(rejestrId, null, !!rejestrId);

    const budzetInicjacja = planHarmData?.inicjacja_budzet_planowany;
    const budzetPrzygotowania = planHarmData?.przygotowania_budzet_planowany;
    const budzetRealizacja = planHarmData?.realizacja_budzet_planowany;
    const budzetZamykania = planHarmData?.zamykania_budzet_planowany;

    useEffect(() => {
        if (!props.wiz || !planHarmData) return;

        const syncKey = [
            budzetInicjacja ?? '0',
            budzetPrzygotowania ?? '0',
            budzetRealizacja ?? '0',
            budzetZamykania ?? '0',
        ].map((v) => String(v)).join('|');

        if (lastSyncedKeyRef.current === syncKey) return;
        lastSyncedKeyRef.current = syncKey;

        const desiredValues = {
            budzet_inicjacja: budzetInicjacja ?? '0',
            budzet_przygotowania: budzetPrzygotowania ?? '0',
            budzet_realizacja: budzetRealizacja ?? '0',
            budzet_zamykania: budzetZamykania ?? '0',
        };

        const current = props.wiz.form || {};
        const isAlreadySynced = Object.entries(desiredValues).every(
            ([k, v]) => String(current?.[k] ?? '') === String(v)
        );

        if (isAlreadySynced) return;

        props.wiz.setWizForm({
            ...current,
            ...desiredValues,
        });
    }, [
        planHarmData,
        budzetInicjacja,
        budzetPrzygotowania,
        budzetRealizacja,
        budzetZamykania,
    ]);

    if (isLoadingPH) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Ładowanie...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <div>
            <JsonViewer src={props.wiz?.form || {}} show={false}/>

            <HeaderTitle noHr size={'fs-3'} title={'Budżet projektu'}/>
            <HeaderTitle
                noHr
                size={'fs-4'}
                title={'Szacowany budżet etapów (z planowanego harmonogramu)'}
            />

            <div className={'d-flex flex-column gap-3'}>

                <Row sm={2}>
                    <Input
                        label={'E.1 Budżet etapu inicjacji [ZŁ]'}
                        value={toCurrency(budzetInicjacja)}
                        className={'text-end'}
                        readOnly
                        disabled={isKatA}
                    />
                </Row>

                <Row sm={2}>
                    <Input
                        label={'E.2 Budżet etapu przygotowania [ZŁ]'}
                        value={toCurrency(budzetPrzygotowania)}
                        className={'text-end'}
                        readOnly
                        disabled={isKatA}
                    />
                </Row>

                <Row sm={2}>
                    <Input
                        label={'E.3 Budżet etapu realizacji [ZŁ]'}
                        value={toCurrency(budzetRealizacja)}
                        className={'text-end'}
                        readOnly
                        disabled={isKatA}
                    />
                </Row>

                <Row sm={2}>
                    <Input
                        label={'E.4 Budżet etapu zamykania [ZŁ]'}
                        value={toCurrency(budzetZamykania)}
                        className={'text-end'}
                        readOnly
                        disabled={isKatA}
                    />
                </Row>
            </div>
        </div>
    )
}

BudzetProjektu.propTypes = {
    wiz: PropTypes.any,
}
